import axios from "axios";
import React, {
  useState,
  useEffect,
  useRef,
  useReducer,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { farmageo_api } from "../../../config";

import OrixiaSpinner from "../components/OrixiaSpinner";

import ListadoContext from "./context/ListadoContext";
import PantallaContext from "../context/PantallaContext";

import FuncionesContext, {
  requestErrorHandler,
} from "../context/FuncionesContext";
import ListadoReducer, { initialState } from "./context/ListadoReducer";
import { useRefDataStore, useRefStore } from "../../..";
import { addData, addsql } from "../context/PantallaReducer";

import ListadoV2 from "./components/Listado";
// import ConfigListado from "./components/ConfigListado";
import { createRowStore } from "./components/Tabla/components/stateWrapper/rowStore";
import {
  createInFlightRequestDeduplicator,
  createRequestSignature,
} from "./requestDeduplicator";
import {
  agregarModoFiltrosAlBody,
  crearQueryFiltrosParaRequest,
  prepararFiltrosParaRefrescar,
} from "../helper/filtrosAlRefrescar";
import { useLocation } from "react-router-dom";
import {
  esValorTodasSelect,
  obtenerValorFiltroConfigurado,
  restaurarValoresTodasEnFiltros,
} from "../helper/opcionesFiltros";

const S = require("sweetalert2");

const objetoQueryFiltrosdeF = (
  filtros,
  filtrosAAplicar,
  pantalla,
  quienLlama
) => {
  let queryfiltros = Object.assign(
    {
      pantalla: pantalla,
    },
    filtrosAAplicar
  );

  filtros.forEach((f) => {
    queryfiltros[f.id_a] = f.default;
    // eslint-disable-next-line no-unused-expressions
    f.sc_hijos?.forEach((fh) => {
      queryfiltros[fh.id_a] = fh.default;
    });
  });

  if (!filtrosAAplicar) return queryfiltros;

  const completarQueryFiltros = (queryfiltros, filtrosAAplicar, f) => {
    const filtroConfigurado = obtenerValorFiltroConfigurado({
      filtros: filtrosAAplicar,
      id_a: f.id_a,
      clave_envio: f.clave_envio,
    });

    if (filtroConfigurado.encontrado) {
      if (typeof filtroConfigurado.valor === "number") {
        queryfiltros[f.id_a] = filtroConfigurado.valor;
      }

      if (typeof filtroConfigurado.valor === "string") {
        queryfiltros[f.id_a] = filtroConfigurado.valor.toString().trim();
      }

      if (Array.isArray(filtroConfigurado.valor)) {
        queryfiltros[f.id_a] = filtroConfigurado.valor.toString().trim();
      }
    }

    if (f.componente === "hidden") {
      queryfiltros[f.id_a] =
        filtrosAAplicar[f.id_a] ?? f.default ?? "filtro_hidden_sin_valor";
    }

    if (
      !queryfiltros[f.id_a] ||
      queryfiltros[f.id_a] === null ||
      queryfiltros[f.id_a]?.toString()?.trim() === "" || // esto sobreescribe los valores de string vacio y los convierte en undefined *** REVISAR
      esValorTodasSelect(queryfiltros[f.id_a]) ||
      filtroConfigurado.valor === null
    ) {
      queryfiltros[f.id_a] = undefined;
      if (f.clave_envio) {
        queryfiltros[f.clave_envio.trim()] = undefined;
      }
    }

    if (f.sc_hijos.length > 0) {
      f.sc_hijos.forEach((h) =>
        completarQueryFiltros(queryfiltros, filtrosAAplicar, h)
      );
    }
  };

  filtros.forEach((f) => {
    completarQueryFiltros(queryfiltros, filtrosAAplicar, f);
  });
  return queryfiltros;
};

export const ListadoProviderV2 = (props) => {
  const {
    configuracion,
    id,
    modalProps,
    qsBody = {},
    subirDatosSeleccionados,
  } = props;
  const modalQsBody = modalProps?.qsBody;
  const location = useLocation();
  const parametrosURL = useMemo(
    () => Object.fromEntries(new URLSearchParams(location.search).entries()),
    [location.search]
  );

  const [loading, setLoading] = useState(false);
  const [carrusel, setCarrusel] = useState(false);
  const [datosListado, setDatosListado] = useState([]); // estado de listado, aunque las filas usan el estado de zuztand

  const [cabeceras, setCabeceras] = useState([]);
  const [filtros, setFiltros] = useState([]);
  const [listadoExtensiones, setListadoExtensiones] = useState([]);
  const [mapaCab, setMapaCab] = useState(
    cabeceras?.filter((c) => c.componente === "mapa").pop()
  );
  const [tieneMapaCab, setTieneMapaCab] = useState(!!mapaCab);
  const [opElegida, setOpElegida] = useState({});

  const handleSetCabeceras = ({ cabeceras, datos }) => {
    const mapaCab = cabeceras.filter((c) => c.componente === "mapa").pop();
    if (mapaCab) {
      setMapaCab(() => mapaCab);
      setTieneMapaCab(true);
    }
    if (datos.length > 0) {
      const nc = cabeceras.filter((c) => {
        const key = `${c.id_a}_CONDICION_ACCESO`;

        const existePropiedad = datos.some((d) =>
          Object.prototype.hasOwnProperty.call(d, key)
        );

        if (!existePropiedad) return true;

        return datos.some((d) => d[key] === 1);
      });
      
      setListadoExtensiones(() =>
        cabeceras.filter((c) => c.tipo.id === 24 || c.componente === "mapa")
      );
      setCabeceras(() => nc);
    }
  };

  const dataStore = useMemo(
    () => createRowStore(configuracion.opciones),
    [configuracion.opciones]
  );
  const initState = dataStore((state) => state.initState);
  const page = dataStore((state) => state.page);
  const rowsPerPage = dataStore((state) => state.rowsPerPage);

  const firstRender = useRef(true);
  const yaAutoEjecute = useRef(
    configuracion.opciones.consultaEjecutada === "s"
  );
  const reclamarAutoActivacion = useCallback(() => {
    if (yaAutoEjecute.current) return false;

    yaAutoEjecute.current = true;
    return true;
  }, []);

  let pantalla = configuracion.opciones.id_a; //ID_A de Listado
  let id_a = configuracion.opciones.id_a; //ID_A de Listado

  const isAutoSeleccion =
    configuracion.opciones?.listado_seleccion !== "s" &&
    !subirDatosSeleccionados &&
    configuracion.opciones?.listado_seleccion_data &&
    configuracion.opciones?.listado_seleccion_data.trim() !== "" &&
    configuracion.opciones?.listado_auto_seleccion === "s";

  const [sideData, setSideData] = useState({});
  const addSideData = useCallback(({ clave_envio, valor }) => {
    setSideData((s) => {
      const newS = { ...s };
      newS[clave_envio] = valor;
      return newS;
    });
  }, []);

  const { pantalla: PPantalla } = useContext(PantallaContext);
  const { obtenerUbicacion } = useContext(FuncionesContext);

  const [state, dispatch] = useReducer(ListadoReducer, initialState);

  const handleCancelar = useCallback(() => {
    dispatch({
      type: "SET_FILTRO_ACTIVO",
      payload: {
        filtros_de_conf: filtros,
        filtros: state.filtrosUsuarioAlCargarPagina,
        funcion: `Boton Cancelar`,
        debug: ["panel de filtros", Date.now()],
      },
    });
    return;
    // return refrescarConfiguracion({
    //   cab: { refrescarConfiguracion: opcionesListado.id_a },
    // });
  }, [filtros, state.filtrosUsuarioAlCargarPagina]);

  useEffect(() => {
    dispatch({ type: "SET_LOADING_PANTALLA", payload: true });
    dispatch({
      type: "SET_ID_GLOBAL",
      payload: id,
    });

    const filtrosUsuario =
      configuracion.opciones.configuracionDeUsuario?.detalles
        .filter((d) => d.conf.tipo.id === 3)
        .map((fu) => {
          return { [fu.conf.id_a]: fu.default };
        })[0];

    dispatch({
      type: "SET_FILTRO_USUARIO_AL_CARGAR_PAGINA",
      payload: filtrosUsuario,
    });

    if (
      configuracion.opciones.iniciar_activo === "s" &&
      configuracion.opciones.alerta_max_resultados_aviso === "n" &&
      reclamarAutoActivacion()
    ) {
      requestData({
        filtrosAAplicar: filtrosUsuario,
        _filtros: configuracion.filtros,
        quienLlama: "useEffect Listado id pantalla",
      });
    }
    //}
    dispatch({
      type: "SET_LOADING_PANTALLA",
      payload: false,
    });
    setLoading(false);
  }, [id, pantalla]);

  const [data, setData] = useRefDataStore((s) => s.listado);
  const [store, setStore] = useRefStore();
  const [requestNro, setRequestNro] = useState(0);
  const deduplicarSolicitudRef = useRef(null);
  if (!deduplicarSolicitudRef.current) {
    deduplicarSolicitudRef.current = createInFlightRequestDeduplicator();
  }

  const ejecutarRequestData = useCallback(
    //As
    async ({
      filtrosAAplicar,
      _filtros,
      quienLlama,
      pagina,
      offset,
      order,
      orderBy,
      qsBodyAdicional,
      reiniciarFiltrosDefaults = false,
    }) => {
      setRequestNro((r) => r + 1);
      if (!_filtros) _filtros = filtros;

      setLoading(true);
      document.body.style.cursor = "progress";

      const parametrosContexto = { ...qsBody, ...parametrosURL };

      let queryfiltros = crearQueryFiltrosParaRequest({
        pantalla,
        reiniciarFiltrosDefaults,
        parametrosContexto,
        crearQuery: () =>
          objetoQueryFiltrosdeF(
            _filtros,
            filtrosAAplicar,
            pantalla,
            "requestData"
          ),
      });
      const filtrosActivos = restaurarValoresTodasEnFiltros({
        filtros: queryfiltros,
        filtrosOriginales: filtrosAAplicar,
        configuracion: _filtros,
      });

      dispatch({
        type: "SET_FILTRO_ACTIVO",
        payload: {
          data,
          filtros_de_conf: configuracion.filtros,
          filtros: filtrosActivos,
          funcion: `requestData funcion ${quienLlama}`,
          debug: [
            "requestData_" + quienLlama,
            filtrosAAplicar,
            _filtros,
            Date.now(),
          ],
        },
      });

      const newBod = agregarModoFiltrosAlBody(
        Object.assign(
          {},
          qsBody,
          qsBodyAdicional,
          sideData,
          modalProps?.qsBody,
          {
            conf_padre: configuracion.opciones.padre,
          }
        ),
        reiniciarFiltrosDefaults,
        parametrosContexto
      );
      newBod.pagina = pagina;
      newBod.offset = offset;
      newBod.order = order;
      newBod.orderBy = orderBy;

      if (!newBod.id) {
        newBod.id = id; // pasa id al body
      }
      let countsql = null;
      if (
        configuracion.opciones.alerta_max_resultados_aviso === "s" &&
        configuracion.opciones.paginar_backend !== "s"
      ) {
        const countRequest = await axios.post(
          farmageo_api + "/listado/contar/" + PPantalla,
          newBod,
          { params: queryfiltros }
        );
        if (countRequest.data.datos) {
          if (countRequest.data.sql)
            setStore({ sql: addsql(countRequest.data.sql, store.sql) });
          countsql = countRequest.data.sql;
          const ans = await S.fire(countRequest.data.message);
          if (ans.isDenied) {
            setLoading(false);
            return;
          }
        }
      }

      if (tieneMapaCab && mapaCab.enviar_geolocalizacion === "s") {
        const ubicacion = await obtenerUbicacion();
        newBod.gps = ubicacion;
      }

      const res = await axios.post(
        farmageo_api + "/config/" + PPantalla,
        newBod,
        { params: queryfiltros }
      );

      if (res.status >= 400) {
        requestErrorHandler(res);
      }
      const datos = res.data?.datos?.meta
        ? res.data.datos.data
        : res.data.datos;

      if (
        res.data.opciones?.listado_seleccion === "s" &&
        subirDatosSeleccionados
      ) {
        subirDatosSeleccionados(datos, res.data.opciones);
      }

      dispatch({
        type: "SOLO_SET_DATOS_SELECCIONADOS",
        payload: [],
      });

      if (isAutoSeleccion) {
        const dataAutoSeleccionada = datos.map((d, i) => {
          const { listado_seleccion_data } = res.data.opciones;
          const nd = {};
          listado_seleccion_data.split("|").forEach((k) => {
            if (d[k]) {
              nd[k] = d[k];
            }
          });
          return nd;
        });

        dispatch({
          type: "SOLO_SET_DATOS_SELECCIONADOS",
          payload: dataAutoSeleccionada,
        });
      }
      try {
        setDatosListado(datos);

        initState(datos);

        setData(addData({ datos }));
        document.body.style.cursor = "unset";

        dispatch({
          type: "SET_OPCIONES_LISTADO",
          payload: Object.assign(res.data?.opciones, modalProps?.props, {
            isAutoSeleccion: isAutoSeleccion,
            filtroRequest: quienLlama === "filtroRequest",
          }),
        });

        if (res.data.opciones.listado_boton_update === "s") {
          dispatch({
            type: "SET_BOTONES_LISTADO",
            payload: res.data.listadoBotones,
          });
          setSideData(() => {
            return {};
          });
        }

        if (res.data.sql) {
          const sqls = countsql ? countsql.concat(res.data.sql) : res.data.sql;
          setStore({ sql: addsql(sqls, store.sql) });
        }

        handleSetCabeceras({
          cabeceras: res.data.cabeceras ? res.data.cabeceras : [],
          datos,
        });
        const filtrosRespuesta = res.data.filtros ? res.data.filtros : [];
        setFiltros(filtrosRespuesta);

        if (reiniciarFiltrosDefaults) {
          setOpElegida({});
          const filtrosDefault = objetoQueryFiltrosdeF(
            filtrosRespuesta,
            {},
            pantalla,
            "defaultsAlRefrescar"
          );
          dispatch({
            type: "SET_FILTRO_ACTIVO",
            payload: {
              data: datos,
              filtros_de_conf: filtrosRespuesta,
              filtros: filtrosDefault,
              funcion: "requestData defaults al refrescar",
              debug: ["defaultsAlRefrescar", filtrosDefault, Date.now()],
            },
          });
        }

        setLoading(false);

        return res;
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    },
    [PPantalla, filtros, id, pantalla, requestErrorHandler, state.id_global]
  );

  const requestData = useCallback(
    (requestOptions) => {
      const {
        filtrosAAplicar,
        _filtros = filtros,
        pagina,
        offset,
        order,
        orderBy,
        qsBodyAdicional,
        reiniciarFiltrosDefaults = false,
      } = requestOptions;

      const parametrosContexto = { ...qsBody, ...parametrosURL };

      const queryfiltros = crearQueryFiltrosParaRequest({
        pantalla,
        reiniciarFiltrosDefaults,
        parametrosContexto,
        crearQuery: () =>
          objetoQueryFiltrosdeF(
            _filtros,
            filtrosAAplicar,
            pantalla,
            "requestDataSignature"
          ),
      });
      const requestBody = agregarModoFiltrosAlBody(
        Object.assign(
          {},
          qsBody,
          qsBodyAdicional,
          sideData,
          modalQsBody,
          {
            conf_padre: configuracion.opciones.padre,
            pagina,
            offset,
            order,
            orderBy,
          }
        ),
        reiniciarFiltrosDefaults,
        parametrosContexto
      );

      if (!requestBody.id) requestBody.id = id;

      const signature = createRequestSignature({
        endpoint: PPantalla,
        params: queryfiltros,
        body: requestBody,
      });

      return deduplicarSolicitudRef.current(signature, () =>
        ejecutarRequestData(requestOptions)
      );
    },
    [
      PPantalla,
      configuracion.opciones.padre,
      ejecutarRequestData,
      filtros,
      id,
      modalQsBody,
      parametrosURL,
      pantalla,
      qsBody,
      sideData,
    ]
  );

  const cambiarPagina = useCallback(
    async (pagina, offset) => {
      if (
        pagina < 0 ||
        (state.opcionesListado.paginacion_backend.currentPage - 1 === pagina &&
          offset === state.opcionesListado.paginacion_backend.offset) ||
        offset < 1
      )
        throw { error: "Error de pagina/offset" };
      await requestData({
        _filtros: filtros,
        filtrosAAplicar: Object.assign(state.filtroActivo, { id }),
        quienLlama: "useEffect refrescante",
        pagina: pagina + 1,
        offset,
      });
    },
    [requestData, filtros, id, state.filtroActivo]
  );

  const ordenarPagina = useCallback(
    async (orderBy, order) => {
      await requestData({
        _filtros: filtros,
        filtrosAAplicar: Object.assign(state.filtroActivo, { id }),
        quienLlama: "useEffect refrescante",
        pagina: page,
        offset: rowsPerPage,
        order,
        orderBy,
      });
    },
    [requestData, filtros, id, state.filtroActivo]
  );

  const cambiarPerPage = useCallback(
    async (pagina, offset) => {
      await requestData({
        _filtros: filtros,
        filtrosAAplicar: Object.assign(state.filtroActivo, { id }),
        quienLlama: "useEffect refrescante",
        pagina: pagina + 1,
        offset,
      });
    },
    [requestData, filtros, id, state.filtroActivo]
  );

  const actualizarListado = useCallback(
    async () =>
      await requestData({
        _filtros: filtros,
        filtrosAAplicar: Object.assign(state.filtroActivo, { id }),
        quienLlama: "useEffect refrescante",
      }),
    [requestData, filtros, id, state.filtroActivo]
  );

  const refrescarEventCallback = useCallback(
    async (event) => {
      if (event.detail === "refrescar") {
        const preparacion = prepararFiltrosParaRefrescar({
          opciones: configuracion.opciones,
          filtroActivo: state.filtroActivo,
          id,
        });
        const res = await requestData({
          _filtros: filtros,
          ...preparacion,
          quienLlama: "useEffect refrescante",
        });

        const event = new CustomEvent("eventNewPantallaData", {
          detail: res.data,
        });
        document.dispatchEvent(event);
      }
    },
    [requestData, configuracion.opciones, filtros, state.filtroActivo, id]
  );

  const actualizarSeleccion = useCallback(
    (event) => {
      if (isAutoSeleccion) {
        const dataAutoSeleccionada = event.detail.datos.map((d, i) => {
          const { listado_seleccion_data } = configuracion.opciones;
          const nd = {};
          listado_seleccion_data.split("|").forEach((k) => {
            const cab = configuracion.cabeceras
              .filter((c) => c.id_a === k)
              .pop();

            if (d[k]) {
              nd[k] = d[k];
              if (cab.clave_envio) {
                nd[cab.clave_envio.trim()] = d[k];
              }
            }
          });
          return nd;
        });

        dispatch({
          type: "SOLO_SET_DATOS_SELECCIONADOS",
          payload: dataAutoSeleccionada,
        });
      }
    },
    [configuracion.cabeceras, configuracion.opciones, isAutoSeleccion]
  );

  useEffect(() => {
    document.addEventListener(id_a, refrescarEventCallback);
    document.addEventListener("eventNewPantallaData", actualizarSeleccion);

    return () => {
      document.removeEventListener(id_a, refrescarEventCallback);
      document.removeEventListener("eventNewPantallaData", actualizarSeleccion);
    };
  }, [actualizarSeleccion, id_a, refrescarEventCallback]);

  useEffect(() => {
    if (firstRender.current) {
      setLoading(true);
      const datos = configuracion.datos.meta
        ? configuracion.datos.data
        : configuracion.datos;

      setDatosListado(datos);

      // datos.forEach((data) => {
      //   initState(data);
      // });
      initState(datos);

      if (
        subirDatosSeleccionados &&
        configuracion.opciones.listado_seleccion !== "s"
      ) {
        subirDatosSeleccionados(datos, configuracion.opciones);
      }

      if (isAutoSeleccion) {
        const dataAutoSeleccionada = datos.map((d, i) => {
          const { listado_seleccion_data } = configuracion.opciones;
          const nd = {};
          listado_seleccion_data.split("|").forEach((k) => {
            if (d[k]) {
              nd[k] = d[k];
            }
          });
          return nd;
        });

        dispatch({
          type: "SOLO_SET_DATOS_SELECCIONADOS",
          payload: dataAutoSeleccionada,
        });
      }

      setData(addData({ datos }));
      handleSetCabeceras({
        cabeceras: configuracion.cabeceras ? configuracion.cabeceras : [],
        datos,
      });
      setFiltros(configuracion.filtros ? configuracion.filtros : []);

      dispatch({
        type: "SET_OPCIONES_LISTADO",
        payload: Object.assign(configuracion.opciones, modalProps?.props, {
          isAutoSeleccion: isAutoSeleccion,
        }),
      });

      dispatch({
        type: "SET_BOTONES_LISTADO",
        payload: configuracion.listadoBotones,
      });

      const filtrosIniciales = Object.assign(
        {},
        modalProps?.props?.filtrosDesdeInput,
        qsBody
      );
      const first_filtrosQuery = objetoQueryFiltrosdeF(
        configuracion.filtros,
        filtrosIniciales,
        pantalla,
        "firstRender"
      );
      const first_filtros = restaurarValoresTodasEnFiltros({
        filtros: first_filtrosQuery,
        filtrosOriginales: filtrosIniciales,
        configuracion: configuracion.filtros,
      });

      dispatch({
        type: "SET_FILTRO_ACTIVO",
        payload: {
          filtros_de_conf: configuracion.filtros,
          filtros: first_filtros,
          funcion: `useEffect Listado PPantalla ${PPantalla}`,
          debug: [
            "firstRender",
            objetoQueryFiltrosdeF(
              configuracion.filtros,
              Object.assign(
                {}, //state.filtroActivo, // bug: este deja pegado los filtros
                modalProps?.props?.filtrosDesdeInput,
                qsBody
              )
            ),
            configuracion.filtros,
            Date.now(),
          ],
        },
      });

      firstRender.current = false;
      dispatch({
        type: "SET_LOADING_PANTALLA",
        payload: false,
      });

      setLoading(false);

      if (
        modalProps?.props?.activarListado &&
        reclamarAutoActivacion()
      ) {
        // se activa el listado por medio de Modal
        // console.log(modalProps?.props)
        requestData({
          _filtros: filtros,
          filtrosAAplicar: first_filtros,
          quienLlama: "useEffect modal - modalProps?.props?.activarListado ",
        });
      }
    }
  }, []);

  return (
    <>
      <ListadoContext.Provider
        value={{
          carrusel,
          cabeceras: cabeceras,
          celdas: state.celdas,
          datos: datosListado,
          datos_seleccionados: state.datos_seleccionados,
          dataStore,
          filtroActivo: state.filtroActivo,
          filtros: filtros,
          filtrosUsuarioAlCargarPagina: state.filtrosUsuarioAlCargarPagina,
          firstRender: firstRender.current,
          id_global: state.id_global,
          listadoBotones: state.listadoBotones,
          listadoExtensiones,
          loading: loading,
          loading_pantalla: state.loading_pantalla,
          mapaCab,
          opElegida,
          opciones: state.opcionesListado,
          opcionesListado: state.opcionesListado,
          pantalla: configuracion.opciones.padre,
          requestNro,
          sideData,
          subirDatosSeleccionados,
          tieneMapaCab,
          useDataStore: dataStore,
          addSideData,
          reclamarAutoActivacion,
          actualizarListado,
          cambiarPagina,
          cambiarPerPage,
          dispatch,
          handleCancelar,
          ordenarPagina,
          requestData, // pasar setQueryFilter para reaccionar a url
          setCarrusel,
          setOpElegida,
        }}
      >
        {state.loading_pantalla ? (
          <div style={{ width: "100vw", textAlign: "center" }}>
            <OrixiaSpinner
              text="Cargando Listado ..."
              style={{ width: "100%", textAlign: "center" }}
            />
          </div>
        ) : (
          <ListadoV2 datos={datosListado} cabeceras={cabeceras} />
        )}
      </ListadoContext.Provider>
    </>
  );
};

export default ListadoProviderV2;
